module.exports = __webpack_public_path__ + "img/neunburg_gemaelde.339c6e59.jpg";